<div #viewUserContainer class="view-user-container">
  <h3 class="text-center everheader">User Profile</h3>
  <div class="mt-4">
    <p>
      You can change user details here. Click on Save once the changes are made.
    </p>
  </div>
  <div class="container mt-3">
    <form [formGroup]="userDetailsFormGroup">
      <div class="row section">
        <div class="col-2">
          <h4 class="form-label mt-3">Name</h4>
        </div>
        <div class="col">
          <div class="d-flex align-items-start mt-3">
            <div>
              <mat-form-field class="editor title-field">
                <mat-label>Title</mat-label>
                <mat-select
                  formControlName="title"
                  id="title"
                  [panelWidth]="null"
                >
                  <mat-option></mat-option>
                  <mat-option
                    *ngFor="let title of titles"
                    [value]="title.value"
                  >
                    {{ title.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="mx-sm-3">
              <mat-form-field class="editor">
                <mat-label>First Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="firstName"
                  id="firstName"
                  required
                />
                <mat-error
                  *ngIf="
                    userDetailsForm.firstName.invalid &&
                    (userDetailsForm.firstName.dirty ||
                      userDetailsForm.firstName.touched)
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="userDetailsForm.firstName.errors.required">
                    First Name is required.
                  </div>
                  <div *ngIf="userDetailsForm.firstName.errors.maxlength">
                    Name must be no more than 64 characters long.
                  </div>
                  <div *ngIf="userDetailsForm.firstName.errors.pattern">
                    Invalid characters in the name.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="editor">
                <mat-label>Last Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="lastName"
                  id="lastName"
                  required
                />
                <mat-error
                  *ngIf="
                    userDetailsForm.lastName.invalid &&
                    (userDetailsForm.lastName.dirty ||
                      userDetailsForm.lastName.touched)
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="userDetailsForm.lastName.errors.required">
                    Last Name is required.
                  </div>
                  <div *ngIf="userDetailsForm.lastName.errors.maxlength">
                    Name must be no more than 64 characters long.
                  </div>
                  <div *ngIf="userDetailsForm.lastName.errors.pattern">
                    Invalid characters in the name.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row section mt-3">
        <div class="col-2">
          <h4 class="form-label mt-3">Email Address</h4>
        </div>
        <div class="col">
          <div class="mt-3">
            <div class="mb-1">
              <mat-form-field class="email-input-field">
                <mat-label>Email Address</mat-label>
                <input
                  type="email"
                  matInput
                  formControlName="emailAddress"
                  id="emailAddress"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row section mt-3">
        <div class="col-2">
          <h4 class="form-label mt-3 text-nowrap">Contact Number</h4>
        </div>
        <div class="col">
          <div class="d-flex align-items-start mt-3">
            <mat-form-field class="editor-phone">
              <mat-label>Phone</mat-label>
              <input
                type="tel"
                matInput
                formControlName="contactPhone"
                id="contactPhone"
              />
              <span class="editor-phone-countrycode mr-1" matTextPrefix>{{
                countryCode$ | async
              }}</span>
              <mat-error
                class="invalid-feedback"
                *ngIf="
                  userDetailsForm.contactPhone.invalid &&
                  (userDetailsForm.contactPhone.dirty ||
                    userDetailsForm.contactPhone.touched)
                "
              >
                <div *ngIf="userDetailsForm.contactPhone.errors.required">
                  Phone Number is required.
                </div>
                <div *ngIf="userDetailsForm.contactPhone.errors.pattern">
                  Only digits are accepted for phone numbers. Please retry.
                </div>
                <div *ngIf="userDetailsForm.contactPhone.errors.maxlength">
                  Phone number entered is too long. Please retry.
                </div>
                <div *ngIf="userDetailsForm.contactPhone.errors.invalidphone">
                  Phone number entered is invalid. Please retry.
                </div>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="editor-phone-ext ml-1">
              <mat-label>Ext</mat-label>
              <input
                type="tel"
                matInput
                formControlName="contactPhoneExt"
                id="contactPhoneExt"
                [readonly]="!userDetailsForm.contactPhone.value"
              />
            </mat-form-field>
          </div>
          <mat-error
            class="invalid-feedback"
            *ngIf="
              userDetailsForm.contactPhoneExt.invalid &&
              (userDetailsForm.contactPhoneExt.dirty ||
                userDetailsForm.contactPhoneExt.touched)
            "
          >
            <div *ngIf="userDetailsForm.contactPhoneExt.errors.pattern">
              Only digits are accepted for phone extension. Please retry.
            </div>
            <div *ngIf="userDetailsForm.contactPhoneExt.errors.maxlength">
              Phone extension entered is too long. Please retry.
            </div>
          </mat-error>
        </div>
      </div>
      <div class="row section mt-3" id="mfa-row" *ngIf="userHasMfa$ | async">
        <div class="col-2">
          <h4 class="form-label mt-3">Multi-Factor Authentication</h4>
        </div>
        <div class="col d-flex align-items-center">
          <mat-icon
            *ngIf="mfaResetting$ | async"
            svgIcon="spinner"
            class="title-icon primary spinner-icon"
          ></mat-icon>
          <div
            id="reset-authentication-button"
            class="reset-authentication"
            [ngClass]="(mfaResetting$ | async) ? 'disabled' : ''"
            (click)="resetMfa()"
          >
            Reset Authentication
          </div>
          <div
            matTooltip="Clicking this button will unenroll the user in MFA, requiring them to go through the enrolment process again next time they log in. Use this if they can no longer access their authenticator."
          >
            ⓘ
          </div>
        </div>
      </div>
    </form>
    <div class="row section mt-3">
      <div class="col">
        <form [formGroup]="rolesFormGroup">
          <div class="row">
            <div class="col-2">
              <h4 class="form-label mt-3">Role</h4>
            </div>
            <div class="col">
              <div class="my-3">
                <div
                  *ngFor="let role of roles; let ind = index"
                  [ngClass]="{ 'mb-3': ind !== roles.length - 1 }"
                >
                  <mat-checkbox
                    [formControlName]="roleMapping.getRoleEnum(role.name)"
                    [id]="roleMapping.getRoleEnum(role.name)"
                    [disabled]="disableAdminRole(role)"
                    >{{
                      roleMapping.getRoleDisplayName(role.name)
                    }}</mat-checkbox
                  >
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    rolesFormGroup.touched &&
                    rolesFormGroup.errors &&
                    rolesFormGroup.errors.requireCheckboxesToBeChecked
                  "
                >
                  The user must have at least one role selected.
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    hasSiteSpecificRole() && (numSiteSelected$ | async) === 0
                  "
                >
                  The user must have at least one site selected.
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="hasSiteSpecificRole()">
            <div class="col-2">
              <h4 class="form-label mt-3">Sites</h4>
            </div>
            <div class="col">
              <div class="mt-3 pt-1">
                Please select the sites you want to grant access to
              </div>
            </div>
          </div>
          <div class="row" *ngIf="hasSiteSpecificRole()">
            <div class="col-2"></div>
            <div class="col pb-3">
              <app-site-permission-editor
                [allSites]="sitesSource$ | async"
                [triggerSitesRefresh]="triggerSitesRefresh$"
                [defaultSite]="currentDefaultSite$ | async"
                [permittedSiteIds]="permittedSites$ | async"
                (sitePermissionChanged)="onSitePermissionChanged($event)"
              ></app-site-permission-editor>
            </div>
          </div>
        </form>
        <div class="row" *ngIf="hasSiteSpecificRole()">
          <div class="col-2">
            <h4 class="form-label mt-3">Default Site</h4>
          </div>
          <div class="col">
            <div class="mt-3">
              <mat-form-field class="default-site-container editor">
                <mat-label>{{
                  (sitesSource$ | async).length > 1 ? 'Select Site' : ''
                }}</mat-label>
                <mat-select
                  [formControl]="defaultSiteFormControl"
                  id="defaultSite"
                  [panelWidth]="null"
                >
                  <mat-option [value]="0">No Default</mat-option>
                  <mat-option
                    *ngFor="
                      let sitePermissionInfo of selectedSites(
                        updatedSitePermission.value
                      )
                    "
                    [value]="sitePermissionInfo.siteInfo.siteId"
                  >
                    {{ sitePermissionInfo.siteInfo.siteName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row section mt-3"></div>
    <div class="row mt-4">
      <div class="col-2">&nbsp;</div>
      <div class="col">
        <div>
          <button
            type="button"
            [disabled]="saving || loading"
            class="everbtnmain"
            (click)="submit()"
          >
            Save
          </button>

          <button
            type="button"
            [disabled]="saving"
            class="everbtn"
            (click)="cancelWindow()"
          >
            Cancel
          </button>
          <mat-spinner *ngIf="saving" diameter="32">Saving...</mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
